<template>
  <v-container class="white py-5" fill-height fluid>

    <div v-if="$vuetify.breakpoint.xsOnly" class="background-image"></div>
    <div v-else class="background-video">
      <video id="priorit-bg-video" autoplay loop muted>
        <source src="/video/Comp3_6.mp4"
                type="video/mp4">
      </video>
    </div>

    <v-row v-if="!$userInfo" align="center" class="fill-height" no-gutters style="z-index: 1">
      <v-col class="login-holder px-xl-16" cols="12" lg="4" md="6" offset-lg="4" offset-md="3" offset-xl="4" xl="4">
        <div class="text-center pb-2">
          <a :alt="$t('title')" href="https://ekd.fi/" target="_blank">
            <img :alt="$t('title')" :style="{width: $vuetify.breakpoint.smAndDown ? '50%' : '60%'}"
                 src="/img/EKD-logo-white.png" style="height: auto;"/>
          </a>
        </div>

        <div :class="$vuetify.breakpoint.xl?'text-weight-bold':''"
             class="headline grey--text text--darken-1 text-center mb-12 mt-4">{{ $t('slogan') }}
        </div>

        <v-row no-gutters>
          <v-card class="ma-0 pa-0" color="transparent" elevation="0" light style="width: 100%">
            <v-row>
              <template v-if="loginType === 'COGNITO'">
                <custom-sign-in
                  v-if="!isSignUp && !isForgotPassword && !isRequireNewPassword"
                  ref="customSignIn"
                  :is-confirm-signup="isConfirmSignUp"
                  :uiComponentProperties="uiComponentProperties"
                  v-bind:signInConfig="signInConfig"
                />

                <custom-require-new-password
                  v-if="isRequireNewPassword"
                  :uiComponentProperties="uiComponentProperties"
                  v-bind:requireNewPasswordConfig="options.requireNewPasswordConfig"
                />

                <custom-forgot-password
                  v-if="isForgotPassword"
                  :uiComponentProperties="uiComponentProperties"
                  class="forgot-password"
                  v-bind:forgotPasswordConfig="forgotPasswordConfig"
                />
                <!--<v-btn
                  :small="$vuetify.breakpoint.xsOnly" block
                  class="font-weight-bold"
                  color="primary"
                  depressed
                  text
                  @click="bookDemo">
                  {{ $t('login.book_a_demo') }}
                </v-btn>-->
              </template>

              <template v-if="!isRequireNewPassword && !isForgotPassword">
                <v-col cols="12">
                  <div class="login-guide text-center grey--text text--darken-1 body-1 mt-5">
                    <p>
                      {{ $t('login.by_clicking_you_agree') }}
                      <a class="primary--text" href="/documents/20250211-terms-of-use.pdf" target="_blank">{{
                          $t('login.terms_of_service')
                        }}</a
                      >.
                    </p>
                    <p>
                      {{ $t('login.to_learn_more_about_privacy') }}
                      <a class="primary--text" href="/documents/20250211-privacy-policy.pdf" target="_blank">{{
                          $t('login.privacy_policy')
                        }}</a
                      >.
                    </p>
                    <div class="text-center body-1 mt-7">
                      <div :style="{fontSize: $vuetify.breakpoint.xsOnly ? '15px' : ''}"
                           class="text-center font-weight-regular pt-4">
                        {{ $t('login.dont_have_account') }}
                        <a href="/signup" style="text-decoration: none;">{{ $t('signup.title') }}</a>
                      </div>
                    </div>
                    <div class="text-center body-1 mt-7">
                      <div :style="{fontSize: $vuetify.breakpoint.xsOnly ? '15px' : ''}"
                           class="text-center font-weight-regular pt-4">
                        {{ $t('login.want_to_try_demo_instead') }}
                        <a @click="loginWithDemo">{{ $t('login.login_with_demo') }}</a>
                      </div>
                    </div>
                    <!--<div class="text-center body-1 mt-7">
                      <div :style="{fontSize: $vuetify.breakpoint.xsOnly ? '15px' : ''}"
                           class="text-center font-weight-regular pt-4">
                        <v-btn :small="$vuetify.breakpoint.xsOnly"
                               class="text-capitalize" color="default" depressed
                               @click="bookDemo">
                          {{ $t('login.book_a_demo') }}
                        </v-btn>
                      </div>
                    </div>-->
                  </div>
                </v-col>
              </template>
            </v-row>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import userApi from '@/api/user';
import UiEventBus from '../UiEventBus';
import UserService from '../service/user.service';
import {AmplifyEventBus, components as amplifyComponents} from 'aws-amplify-vue';
import CustomSignIn from '../components/Login/SignIn.vue';
import CustomForgotPassword from '../components/Login/ForgotPassword.vue';
import CustomRequireNewPassword from '../components/Login/RequireNewPassword.vue';

export default {
  name: 'LoginView',
  data() {
    return {
      loginType: 'COGNITO',
      uiComponentProperties: {
        rounded: false,
        text: true,
        outlined: true,
        buttonColor: 'primary',
        buttonClass: '', // primary nappien luokat, esim. tekstin väri
        inputColor: 'primary',
      },
      signInConfig: {
        header: this.$t('login.login'),
        isSignUpDisplayed: false,
      },
      signUpConfig: {
        defaultCountryCode: '358',
        signUpFields: [
          {
            label: this.$Amplify.I18n.get('Username'),
            key: 'username',
            required: true,
            type: 'string',
            displayOrder: 1,
          },
          {
            label: this.$Amplify.I18n.get('Email'),
            key: 'email',
            required: true,
            type: 'string',
            displayOrder: 2,
          },
        ],
        hiddenDefaults: ['phone_number', 'username'],
      },
      authConfig: {},
      forgotPasswordConfig: {},
      isSignUp: false,
      isConfirmSignUp: false,
      isForgotPassword: false,
      isRequireNewPassword: false,
    };
  },
  computed: {
    options() {
      const defaults = {
        signInConfig: {},
        signUpConfig: {},
        confirmSignUpConfig: {},
        confirmSignInConfig: {},
        forgotPasswordConfig: {},
        mfaConfig: {},
        requireNewPasswordConfig: {},
      };
      return Object.assign(defaults, this.authConfig);
    },
  },
  methods: {
    bookDemo() {
      //window.open("https://meetings-eu1.hubspot.com/antti-suikkanen/prioritio30-minute-meeting", "_blank");
    },
    async getCurrentUser() {
      try {
        const cognitoUser = await this.$Amplify.Auth.currentAuthenticatedUser();
        this.$store.commit('setLoadingOverlay', true);
        UserService.cognitoLogin(cognitoUser);
        const me = await userApi.getMe();
        UserService.setUserInfo(me);
        UiEventBus.$emit('loginSuccess');
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    loginWithDemo() {
      this.$refs.customSignIn.options.username = 'demo@priorit.io';
      this.$refs.customSignIn.password = 'oxG6Hi7h*wA&dFga6x*gfxuCE&^UQXHpv';
      this.$refs.customSignIn.signIn();

    }
  },
  created() {
    AmplifyEventBus.$on('localUser', user => {
      this.user = user;
      this.options.signInConfig.username = this.user.username;
      this.options.confirmSignInConfig.user = this.user;
      this.options.confirmSignUpConfig.username = this.user.username;
      this.options.requireNewPasswordConfig.user = this.user;
    });
    AmplifyEventBus.$on('authState', state => {
      this.isRequireNewPassword = state === 'requireNewPassword';
      this.isSignUp = state === 'signUp';
      this.isConfirmSignUp = state === 'confirmSignUp';
      this.isForgotPassword = state === 'forgotPassword';
      if (state === 'signedIn') {
        this.getCurrentUser();
      }
    });
  },
  beforeDestroy() {
    AmplifyEventBus.$off('localUser');
    AmplifyEventBus.$off('authState');
  },
  mounted() {
    if (this.$isLoggedIn) {
      this.$store.commit('setLoadingOverlay', false);
      this.$router.push({name: 'start'});
    } else {
      if (this.$route?.query?.email_confirmed == "1") {
        this.$showSuccessNotification(this.$t('login.email_confirmed'));
      }
    }
  },
  components: {
    CustomSignIn,
    CustomForgotPassword,
    CustomRequireNewPassword,
    ...amplifyComponents,
  },
};
</script>

<style lang="scss" scoped>
.background-image {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: contain;
  background-position: bottom right;
  opacity: 0.07;
}

.background-video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}

#priorit-bg-video {
  object-fit: fill;
  height: 100%;
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .background-image {
    opacity: 0.2;
  }
}
</style>
